import { Spin } from 'antd'
import { FC } from 'react'

import Styles from './Spinner.module.scss'

export const Spinner: FC<unknown> = () => {
    return <Spin className={Styles.container} />
}
